// https://spin.atomicobject.com/typescript-flexible-nominal-typing/
interface Flavoring<FlavorT> {
  _type?: FlavorT;
}
export type Flavor<T, FlavorT> = T & Flavoring<FlavorT>;

export type MenuId = Flavor<string, 'MenuId'>;

/**
 * - 'unauthorized' - user is not authorized to access these MenuIds
 * - 'error' - API call failed for some other reason
 */
export enum ResponseFailure {
  Unauthorized = 'Unauthorized',
  Error = 'Error',
}

/**
 * One of:
 * - type argument T - valid response data from API, could be empty object/array/string
 * - ResponseFailure
 * - undefined - API call not yet made
 */
export type Response<T> = NonNullable<T> | ResponseFailure | undefined;

export type MenuIdsResponse =
  | MenuId[]
  | null
  | 'error'
  | 'unauthorized'
  | undefined;

export enum RequestStatus {
  Idle = 'Idle',
  Pending = 'Pending',
}
